import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import RfqForm from "./RfqForm";

export default function EnquiryModal({ open, onClose, product, products = [] }) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose?.()}>
      <DialogContent
        data-testid="rfq-modal"
        className="max-h-[90vh] max-w-xl overflow-y-auto rounded-3xl bg-white p-6 sm:p-8"
      >
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-semibold text-ink">
            Request for Quotation
          </DialogTitle>
          <DialogDescription className="text-sm leading-relaxed text-slate-500">
            {product
              ? `Tell us your requirement for ${product.name} — we reply within 24 hours with pricing, specifications and shipping terms.`
              : "Share your requirement — our export desk replies within 24 hours."}
          </DialogDescription>
        </DialogHeader>
        <RfqForm
          key={product?.slug || "general"}
          products={products}
          defaultProduct={product?.slug || "general"}
        />
      </DialogContent>
    </Dialog>
  );
}
